import { render } from "./CatalogCardComp.vue?vue&type=template&id=0dd56ce4&scoped=true&ts=true"
import script from "./CatalogCardComp.vue?vue&type=script&lang=ts"
export * from "./CatalogCardComp.vue?vue&type=script&lang=ts"

import "./CatalogCardComp.vue?vue&type=style&index=0&id=0dd56ce4&lang=scss"
import "./CatalogCardComp.vue?vue&type=style&index=1&id=0dd56ce4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd56ce4"]])

export default __exports__